import Aguardando from '../../../assets/aguardando.svg'
import TitleFooter from '../../atoms/TitleFooter'
import TextFooter from '../../atoms/TextFooter'
import * as Styled from './style'

export default function AlertAguardando() {
  return (
    <Styled.Container role="status" aria-live="polite">
      <Styled.Glow />
      <Styled.IconCircle>
        <span className="ping" aria-hidden="true" />
        <img src={Aguardando} alt="Aguardando" />
      </Styled.IconCircle>

      <Styled.TextBlock>
        <span>Aguarde</span>
        <strong>Cadastro sendo verificado</strong>
        <Styled.Progress aria-hidden="true" />
      </Styled.TextBlock>

      <Styled.Spinner aria-hidden="true" />
    </Styled.Container>
  )
}
